import React, { useLayoutEffect, useState } from "react";
import { FormControlLabel, FormLabel, Grid, Radio, RadioGroup, TextField } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

import {
  BACKEND_BASE_URL,
  GET_CATEOGORY_DATA,
  SET_CATEOGORY_DATA,
  AXIOS_TIMEOUT,
  HotelRoomCateogory,
  printDebugLog,
} from "../../constants/Constants";
import axios from "axios";
import DialogBox from "../../global/DialogBox";
import {
  Button,
} from "@mui/material";
import CustomDataGrid from "../../global/CustomDataGrid";
import useAuth from "../../hooks/useAuth";
import { CATGCREATION, CATGUPDATE } from "../../constants/Permissions";

export default function Category() {
  const { activeShopHash, authUser, isRoleAllowed } = useAuth();

  const [isDataLoaded, setDataLoaded] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);

  const [categorySingleData, setSingleCategoryData] = useState({
    id: "",
    catgName: "",
    type: HotelRoomCateogory.HOTEL_ROOM,
    typeStr: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    //console.log("handleInputChange",name , value);
    setSingleCategoryData({
      ...categorySingleData,
      [name]: value,
    });
    //console.log("setSingleCategoryData-> ",categorySingleData);
  };

  const columns = [
    { field: "catgName", headerName: "Category Name", width: 300 },
    { field: "typeStr", headerName: "Type", width: 300 },
    {
      field: "Edit",
      headerName: "Edit",
      width: 70,
      renderCell: (cellValues) => {
        return (
          <EditIcon
            onClick={(event) => {
              if (isRoleAllowed(CATGUPDATE)) {
                handleCellClick(event, cellValues);
              }
            }}
          ></EditIcon>
        );
      },
    },
  ];

  const handleCellClick = (param, event) => {
    setSingleCategoryData({
      ...categorySingleData,
      id: event.row.id,
      catgName: event.row.catgName,
    });
    //console.log("setSingleCategoryData : ",categorySingleData);
    setEdit(true);
    setShowDialog(true);
  };

  const handleSubmitCatg = async () => {
    setFormSubmitted(true);
    if (!isValid()) {
      return;
    }
    setDataLoaded(false);
    const catgUrl = `${BACKEND_BASE_URL}${SET_CATEOGORY_DATA}`;
    const filledData = {
      payLoad: {
        apiToken: authUser.apiToken,
        shopHash: activeShopHash.id,
        catgName: categorySingleData.catgName,
        id: categorySingleData.id,
        type: categorySingleData.type,
      },
    };
    //console.log("handleSubmitCatg => ",filledData);
    handleDialogClose();
    try {
      const response = await axios.post(catgUrl, filledData, {
        timeout: AXIOS_TIMEOUT,
      });

      printDebugLog("handleSubmitCatg", response);
      setDataLoaded(true);
      getCateogoryData();
    } catch (error) {
      console.log("error : ", error);
      setDataLoaded(true);
      // window.location.href = "#/error";
    }
  };

  const getCateogoryData = async () => {
    if (!authUser)
      return;
    //console.log("getCateogoryData => ",authUser , activeShopHash);
    let catgUrl =
      BACKEND_BASE_URL + GET_CATEOGORY_DATA;
    let data = {
      payLoad: {
        apiToken: authUser.apiToken,
        shopHash: activeShopHash.id,
      },
    };
    //   console.log("verifyCredentials => ",data);
    axios
      .post(catgUrl, data)
      .then((response) => {
        setDataLoaded(true);
        setCategoryData(response.data.payLoad.data);
      })
      .catch((error) => {
        setDataLoaded(true);
        console.log("Error : ", error);
        //window.location.href = "#/error";
      });
  };

  const getErrorMessage = (field) => {
    if (!formSubmitted) {
      return;
    } else if (!categorySingleData[field]) {
      return 'Field is required';
    }
  }

  useLayoutEffect(() => {
    //  console.log('Printing Login Details : ',CART_INITIAL_STATE);
    getCateogoryData(0, 10);
  }, []);

  const renderDialogContent = () => {
    return (
      <React.Fragment>
        <Grid container spacing={1}>
          <Grid item xs={12} md={12} sm={12} lg={12}>
            <TextField
              required
              id="cateog-Name"
              label="Enter Category Name"
              name="catgName"
              variant="filled"
              size="small"
              defaultValue={categorySingleData.catgName}
              onChange={handleInputChange}
              error={formSubmitted && !categorySingleData.catgName}
              helperText={getErrorMessage('catgName')}
            />
          </Grid>
          <Grid item md={12} xs={12} sm={12} lg={12}>
            <FormLabel component="legend">Enter Type :</FormLabel>
            <RadioGroup row aria-label="type" name="type" value={categorySingleData.type} onChange={handleInputChange} >
              <FormControlLabel value={HotelRoomCateogory.HOTEL_ROOM} control={<Radio />} label="Only Room" />
              <FormControlLabel value={HotelRoomCateogory.HOTEL_BANKQUET} control={<Radio />} label="Only Banquet" />
              <FormControlLabel value={HotelRoomCateogory.HOTEL_BOTH} control={<Radio />} label="Room/Banquet" />
            </RadioGroup>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  const renderDialogAction = () => {
    return (
      <React.Fragment>
        {
          <Button variant="contained" color="primary" onClick={handleSubmitCatg}>
            {!isEdit ? "Add" : "Update"}
          </Button>
        }
        <Button variant="contained" color="primary" onClick={handleDialogClose}>
          Dismiss
        </Button>
      </React.Fragment>
    );
  };

  const handleDialogClose = () => {
    // console.log("handleDialogClose");
    setSingleCategoryData({
      ...categorySingleData,
      id: "",
      catgName: "",
    });
    setEdit(false);
    setShowDialog(false);
    setFormSubmitted(false);
  };

  const isValid = () => {
    let isCategoryDataValid = true;

    if (!categorySingleData.catgName) {
      isCategoryDataValid = false;
    }

    return isCategoryDataValid;
  }

  return (
    <React.Fragment>
      <Grid container spacing={3}>
        {/* <Grid item xs={12}>
        </Grid> */}
        <Grid item xs={12} style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ padding: 10 }}>
            <Button
              variant="contained"
              color="primary"
              style={{ float: "right" }}
              onClick={(e) => {
                if (isRoleAllowed(CATGCREATION)) {
                  setShowDialog(true);
                }
              }}
            >
              Add New Cateogory
            </Button>
          </div>

          <CustomDataGrid
            getRowId={row => row.id}
            rows={categoryData}
            columns={columns}
            loading={!isDataLoaded}
            title="Show All Cateogory"
          />
        </Grid>
      </Grid>
      <DialogBox
        showDialog={showDialog}
        title={isEdit ? "Edit Cateogory" : "Add New Cateogory"}
        onClose={handleDialogClose}
        dialogContent={renderDialogContent()}
        dialogActions={renderDialogAction()}
      ></DialogBox>
    </React.Fragment>
  );
}
